import React, { useEffect, useState } from "react";
import "./MultiSelectInput.css";
import Dates from "./Dates.jsx";
import moment from "moment";

const MultiSelectInput = (props) => {
    //установка по дефолту
    useEffect(() => {
        props?.place === "Тарифы"
            ? null
            : !props.thisDates && props.setSelectedOptions([...props.options]);
    }, []);

    const [isOpen, setIsOpen] = useState(false);

    const handleOptionToggle = (option) => {
        //тарифы обычный не мультиселект
        if (props?.place === "Тарифы") {
            props.setSelectedOptions([option]);
            setIsOpen(false);
            return;
        }

        const index = props.selectedOptions.findIndex(
            (item) => item.id === option.id,
        );
        if (index === -1) {
            props.setSelectedOptions([...props.selectedOptions, option]);
        } else {
            props.setSelectedOptions(
                props.selectedOptions.filter((item) => item.id !== option.id),
            );
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        props.setLastOpen(props.place);
    };

    //закрываем другие селекты
    useEffect(() => {
        if (props.lastOpen !== props.place) {
            setIsOpen(false);
        }
    }, [props.lastOpen]);

    const onDateChange = (dates) => {
        const [start, end] = dates;
        props.setStartDate(start);
        props.setEndDate(end);
        if (end) {
            setIsOpen(false);
        }
    };

    const handleOnBlur = () => {
        props.setLastOpen("");
    };

    //мультиселект для всех
    const allOption =
        !props.thisDates &&
        props?.options?.map((option) => (
            <div
                className={`dropdown-item ${props?.selectedOptions?.some((item) => item.id === option.id) ? "selected" : ""}`}
                key={option.id + option.name}
                onClick={() => handleOptionToggle(option)}
            >
                {option.name}
                {props?.selectedOptions?.some(
                    (item) => item.id === option.id,
                ) && <div className="check-icon">{redCheckIcon}</div>}
            </div>
        ));

    //мультиселект календаря
    const calendarOption = (
        <>
            <Dates
                startDate={props.startDate}
                endDate={props.endDate}
                onDateChange={onDateChange}
                isOpen={isOpen}
            />
        </>
    );

    return (
        <div className="multiselect-input">
            <div className={`dropdown ${isOpen ? "open" : ""}`}>
                <div className="dropdown-toggle" onClick={toggleDropdown}>
                    <div className="label">{props.place}</div>
                    <span className={"multi-text"}>
                        {props?.thisDates
                            ? props.dateString
                            : props?.thisRates
                              ? props.selectedOptions
                                    .map((option) => option.name)
                                    .join(", ")
                              : props.selectedOptions.length ===
                                  props.options.length
                                ? "Выбраны все " + props.place
                                : props.selectedOptions.length === 0
                                  ? "Выберите " + props.place
                                  : "Выбрано " +
                                    props.selectedOptions.length +
                                    " " +
                                    props.place}
                    </span>
                    {props?.thisDates ? calendarIcon : cursorDownIcon}
                    <div className="label-down">{props.downLabel}</div>
                </div>
                <div
                    className={
                        "dropdown-menu" +
                        (props?.thisDates ? " dropdown-menu-dates" : "")
                    }
                >
                    {isOpen && props.thisDates ? calendarOption : allOption}
                </div>
            </div>
        </div>
    );
};

export default MultiSelectInput;

const calendarIcon = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 2V5"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 2V5"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 9.09H20.5"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.6947 13.7H15.7037"
            stroke="#292D32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.6947 16.7H15.7037"
            stroke="#292D32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9955 13.7H12.0045"
            stroke="#292D32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9955 16.7H12.0045"
            stroke="#292D32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.29431 13.7H8.30329"
            stroke="#292D32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.29431 16.7H8.30329"
            stroke="#292D32"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const cursorDownIcon = (
    <svg
        width="8"
        height="4"
        viewBox="0 0 8 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.38181 0H3.82198H0.616412C0.0678664 0 -0.206406 0.607131 0.182147 0.963036L3.14201 3.67419C3.61627 4.1086 4.38767 4.1086 4.86193 3.67419L5.98759 2.64311L7.82179 0.963036C8.20463 0.607131 7.93036 0 7.38181 0Z"
            fill="#1F1F1F"
        />
    </svg>
);

const redCheckIcon = (
    <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2935 0.259425C11.5867 0.58512 11.5651 1.09117 11.2452 1.38973L4.38807 7.78972C4.08768 8.07009 3.62661 8.07009 3.32622 7.78972L0.754792 5.38972C0.434913 5.09117 0.413304 4.58512 0.706526 4.25942C0.999749 3.93373 1.49677 3.91173 1.81664 4.21028L3.85714 6.11475L10.1834 0.210281C10.5032 -0.0882725 11.0003 -0.0662702 11.2935 0.259425Z"
            fill="#DE210B"
        />
    </svg>
);
